import gql from 'graphql-tag';
import {
  condominiumMaintenanceModeFragment,
  maintenancePropagationPlaceFragment,
} from './fragments';

export const condominiumMaintenanceModes = gql`
  query condominiumMaintenanceModes($condominiumPersonContextId: Int!) {
    condominiumMaintenanceModes(
      condominiumPersonContextId: $condominiumPersonContextId
    ) {
      maintenanceModes {
        ...condominiumMaintenanceModeParts
      }
    }
  }
  ${condominiumMaintenanceModeFragment}
`;

export const placeMaintenancePropagation = gql`
  query placeMaintenancePropagation($placeId: Int!) {
    placeMaintenancePropagation(placeId: $placeId) {
      willPauseInterlock
      interlockedPlaceIds
      places {
        ...maintenancePropagationPlaceParts
      }
    }
  }
  ${maintenancePropagationPlaceFragment}
`;
